import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil.js';
import FJAnchor from './FJAnchor';
import _ from 'lodash';
import Style from './FJDropdownNew.module.less';
import FJDropDownManager from '../../js/FJDropDownManager.js';

const _judgeBrowser = () => {
    let userAgent = navigator.userAgent;
    let isFF = userAgent.indexOf('Firefox') > -1;
    let isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1;
    return {
        isFF,
        isChrome,
    };
};

class FJDropdownNew extends Component {
    _isBindEvent = false;
    constructor(props) {
        super(props);
        this.state = {
            shown: false,
            left: 0,
            top: 0,
        };
        this._menu = createRef();
        this.overlayEle = createRef();
        this.triggerEle = createRef();
        // 下拉菜单等级，1级面板，2级面板，3级面板...，默认为1级面板
        this._level = props.level || 1;
        this._placement = props.placement || 'bottomCenter';
        if (!props.ignoreManager) this._id = FJDropDownManager.createId();
    }

    componentWillUnmount() {
        this._unbindEvent();
        if (!this.props.ignoreManager)
            FJDropDownManager.hide({ id: this._id, level: this._level, hideFunction: this._hide }, true);
    }

    _bindEvent = () => {
        if (this._isBindEvent) return;
        const { trigger = 'click', isNeedBindWheelEvent = true, ignoreManager } = this.props;
        if (ignoreManager)
            FJUtil.addEvent(document.body, trigger === 'click' ? 'mousedown' : 'mousemove', this._onMouseDown);
        if (isNeedBindWheelEvent && trigger === 'click') this._addWheelEvent();
        window.addEventListener('resize', this._onResize);
        this._isBindEvent = true;
    };
    _unbindEvent = () => {
        if (!this._isBindEvent) return;
        let { trigger = 'click', isNeedBindWheelEvent = true, ignoreManager } = this.props;
        if (ignoreManager)
            FJUtil.removeEvent(document.body, trigger === 'click' ? 'mousedown' : 'mousemove', this._onMouseDown);
        if (isNeedBindWheelEvent && trigger === 'click') this._removeWheelEvent();
        window.removeEventListener('resize', this._onResize);
        this._isBindEvent = false;
    };

    _addWheelEvent = () => {
        let { isFF, isChrome } = _judgeBrowser();
        if (isFF) {
            document.addEventListener('DOMMouseScroll', this._onMousewheel);
        } else if (isChrome) {
            document.addEventListener('scroll', this._onMousewheel);
        }
    };
    _removeWheelEvent = () => {
        let { isFF, isChrome } = _judgeBrowser();
        if (isFF) {
            document.removeEventListener('DOMMouseScroll', this._onMousewheel);
        } else if (isChrome) {
            document.removeEventListener('scroll', this._onMousewheel);
        }
    };

    /*************************** event action ***************************/
    _checkCanBeHide = e => {
        const { couldEventHide = true } = this.props;
        const isInTriggerArea = FJUtil.isPanelArea(e, this.getTriggerEle());
        const isInOverlayArea = FJUtil.isPanelArea(e, this.getOverlayEle());
        let isInConnectRect = false;
        const connectRect = this._getConnectRect();
        if (connectRect) {
            const point = { x: e.clientX, y: e.clientY };
            isInConnectRect = FJUtil.isPointInRect(point, connectRect);
        }
        return couldEventHide && !isInTriggerArea && !isInOverlayArea && !isInConnectRect;
    };
    _onMousewheel = e => {
        this._removeWheelEvent();
        this.hide(e);
    };
    _onMouseDown = e => {
        e.stopPropagation();
        if (this._checkCanBeHide(e)) {
            this.hide(e);
        }
    };
    _onResize = () => {
        if (this.state.shown) {
            this._resizeDebounce =
                this._resizeDebounce ||
                _.debounce(() => {
                    this.fitPosition();
                }, 300);
            this._resizeDebounce();
        }
    };
    /**
     * @desc 点击按钮，打开或关闭面板
     * @param e
     * @private
     */
    _onClick = e => {
        let { disabled, triggerClick } = this.props;

        if (disabled) {
            return;
        }

        if (triggerClick && !this.state.shown) {
            triggerClick(e);
        }

        this.state.shown ? this.hide(e) : this.show(e);
    };

    _show = e => {
        if (this.state.shown || this.props.disabled) return;
        this.setState({ shown: true }, () => {
            this._updateAfterShownChanged(e);
        });
    };
    show = e => {
        if (this.state.shown || this.props.disabled) return;
        if (!this.props.ignoreManager) {
            const { trigger = 'click' } = this.props;
            FJDropDownManager.show({
                id: this._id,
                trigger: trigger,
                level: this._level,
                checkCanBeHide: this._checkCanBeHide,
                hideFunction: this._hide,
                showFunction: this._show,
            });
        } else this._show(e);
    };
    _hide = e => {
        if (!this.state.shown || this.props.disabled) return;
        this.setState({ shown: false }, () => {
            this._updateAfterShownChanged(e);
        });
    };
    hide = e => {
        if (!this.props.ignoreManager)
            FJDropDownManager.hide({ id: this._id, level: this._level, hideFunction: this._hide });
        else this._hide(e);
    };

    isShow = () => {
        return this.state.shown;
    };

    // 得到按钮与菜单间的间隙的空间，当点击这些空间时，也应该被认为是点中了菜单，而不会触发关闭
    _getConnectRect = () => {
        if (!this.getOverlayEle()) return;
        const { offsetX = 0, offsetY = 0 } = this.props;
        const { left, top } = this.state;
        let { width, height } = this.getOverlayEle().getBoundingClientRect();
        let rect;

        switch (this._placement) {
            case 'bottomLeft':
            case 'bottomCenter':
            case 'bottomRight': {
                if (offsetY > 0) {
                    rect = { x: left, y: top - offsetY, width: width, height: offsetY };
                }
                break;
            }
            case 'topLeft':
            case 'topCenter':
            case 'topRight': {
                if (offsetY > 0) {
                    rect = { x: left, y: top + height, width: width, height: offsetY };
                }
                break;
            }
            case 'rightTop':
            case 'rightCenter':
            case 'rightBottom': {
                if (offsetX > 0) {
                    rect = { x: left - offsetX, y: top, width: offsetX, height: height };
                }
                break;
            }
            case 'leftTop':
            case 'leftCenter':
            case 'leftBottom': {
                if (offsetX > 0) {
                    rect = { x: left + width, y: top, width: offsetX, height: height };
                }
                break;
            }
            default:
                break;
        }
        return rect;
    };

    /**
     * @desc 自适应更新面板的位置
     */
    fitPosition = () => {
        if (!this.getTriggerEle() || !this.getOverlayEle()) {
            return;
        }

        // offsetX,offsetY为面板的偏移
        // 下拉菜单相对显示窗口的padding，用于判断是否超过可显示区域而重新定位
        const { offsetX = 0, offsetY = 0, menuPadding = { left: 0, right: 0, top: 0, bottom: 0 } } = this.props;
        const windowSize = { width: document.body.offsetWidth, height: document.body.offsetHeight };
        const visibleRect = {
            x: menuPadding.left,
            y: menuPadding.top,
            width: windowSize.width - menuPadding.left - menuPadding.right,
            height: windowSize.height - menuPadding.top - menuPadding.bottom,
        };
        let triggerRect = this.getTriggerEle().getBoundingClientRect();
        let overlayRect = this.getOverlayEle().getBoundingClientRect();

        // TODO: 为了区分主要布局的差异，所以没把获取的方法写在一起以免造成逻辑上的理解成本,主布局指的是面板相对于按钮的位置在上下左右4个方向上，次布局为相对于按钮的横坐标或纵坐标上如何对齐
        // 适用于主布局为上下结构
        const __getTopWithMainLayout = vertical => {
            let top;
            switch (vertical.toLowerCase()) {
                case 'top':
                    top = triggerRect.top - overlayRect.height - offsetY;
                    break;
                case 'bottom':
                    top = triggerRect.top + triggerRect.height + offsetY;
                    break;
                default:
                    top = triggerRect.top + triggerRect.height;
                    break;
            }
            return top;
        };
        // 适用于主布局为左右结构
        const __getLeftWithMainLayout = horizontal => {
            let left;
            switch (horizontal.toLowerCase()) {
                case 'left':
                    left = triggerRect.left - overlayRect.width - offsetX;
                    break;
                case 'right':
                    left = triggerRect.left + triggerRect.width + offsetX;
                    break;
                default:
                    left = triggerRect.left + triggerRect.width;
                    break;
            }
            return left;
        };
        // 次要布局，获取对齐横坐标的top值
        const __getTopWithSubLayout = vertical => {
            let top;
            switch (vertical.toLowerCase()) {
                case 'top':
                    top = triggerRect.top;
                    break;
                case 'center':
                    top = triggerRect.top + triggerRect.height / 2 - overlayRect.height / 2;
                    break;
                case 'bottom':
                    top = triggerRect.top + triggerRect.height - overlayRect.height;
                    break;
                default:
                    top = triggerRect.top;
                    break;
            }
            return top;
        };
        // 次要布局，获取对齐纵坐标的left值
        const __getLeftWithSubLayout = horizontal => {
            let left;
            switch (horizontal.toLowerCase()) {
                case 'left':
                    left = triggerRect.left;
                    break;
                case 'center':
                    left = triggerRect.left + triggerRect.width / 2 - overlayRect.width / 2;
                    break;
                case 'right':
                    left = triggerRect.left + triggerRect.width - overlayRect.width;
                    break;
                default:
                    left = triggerRect.left;
                    break;
            }
            return left;
        };
        // 检查position是否在可显示区域内
        const __check = position => {
            return (
                position.left > visibleRect.x &&
                position.left + overlayRect.width < visibleRect.x + visibleRect.width &&
                position.top > visibleRect.y &&
                position.top + overlayRect.height < visibleRect.y + visibleRect.height
            );
        };

        const __getPosition = (placement, adaptive = false) => {
            let left;
            let top;
            let newPlacement;
            switch (placement) {
                // 主布局为上下布局
                case 'bottomLeft':
                case 'bottomCenter':
                case 'bottomRight': {
                    let vertical = 'bottom';
                    let horizontal = placement.replace('bottom', '');
                    top = __getTopWithMainLayout(vertical);
                    left = __getLeftWithSubLayout(horizontal) + offsetX;
                    if (adaptive) {
                        if (top + overlayRect.height > visibleRect.y + visibleRect.height) vertical = 'top';
                        if (left < visibleRect.x) horizontal = 'Right';
                        else if (left + overlayRect.width > visibleRect.x + visibleRect.width) horizontal = 'Left';
                        newPlacement = vertical + horizontal;
                    }
                    break;
                }
                case 'topLeft':
                case 'topCenter':
                case 'topRight': {
                    let vertical = 'top';
                    let horizontal = placement.replace('top', '');
                    top = __getTopWithMainLayout(vertical);
                    left = __getLeftWithSubLayout(horizontal) + offsetX;
                    if (adaptive) {
                        if (top < visibleRect.y) vertical = 'bottom';
                        if (left < visibleRect.x) horizontal = 'Right';
                        else if (left + overlayRect.width > visibleRect.x + visibleRect.width) horizontal = 'Left';
                        newPlacement = vertical + horizontal;
                    }
                    break;
                }
                // 主布局为左右布局
                case 'rightTop':
                case 'rightCenter':
                case 'rightBottom': {
                    let horizontal = 'right';
                    let vertical = placement.replace('right', '');
                    left = __getLeftWithMainLayout(horizontal);
                    top = __getTopWithSubLayout(vertical) + offsetY;
                    if (adaptive) {
                        if (left + overlayRect.width > visibleRect.x + visibleRect.width) horizontal = 'left';
                        if (top < visibleRect.y) vertical = 'Top';
                        else if (top + overlayRect.height > visibleRect.y + visibleRect.height) vertical = 'Bottom';
                        newPlacement = horizontal + vertical;
                    }
                    break;
                }
                case 'leftTop':
                case 'leftCenter':
                case 'leftBottom': {
                    let horizontal = 'left';
                    let vertical = placement.replace('left', '');
                    left = __getLeftWithMainLayout(horizontal);
                    top = __getTopWithSubLayout(vertical) + offsetY;
                    if (adaptive) {
                        if (left < visibleRect.x) horizontal = 'right';
                        if (top < visibleRect.y) vertical = 'Top';
                        else if (top + overlayRect.height > visibleRect.y + visibleRect.height) vertical = 'Bottom';
                        newPlacement = horizontal + vertical;
                    }
                    break;
                }

                default:
                    left = triggerRect.left - overlayRect.width / 2 + triggerRect.width / 2;
                    top = triggerRect.top + triggerRect.height;
                    break;
            }

            if (adaptive && newPlacement !== placement) {
                const p = __getPosition(newPlacement);
                if (__check(p)) {
                    left = p.left;
                    top = p.top;
                } else {
                    newPlacement = '';
                }
            }
            return { left, top, newPlacement };
        };

        // 布局方式，由2个上下左右的单词组成，其中前面为主布局后面为次要布局
        const placement = this.props.placement || 'bottomCenter';
        const { left, top, newPlacement } = __getPosition(placement, true);
        this._placement = newPlacement || placement;
        this.setState({ left: left, top: top });
    };
    /**
     * @desc 获取响应下拉菜单显示或隐藏的组件
     * @return {unknown}
     */
    getTriggerEle = () => {
        return this.triggerEle.current;
    };
    /**
     * @desc 下拉菜单面板
     * @return {unknown}
     */
    getOverlayEle = () => {
        return this.overlayEle.current;
    };
    /**
     * @desc 当显示隐藏更新后，执行的一些业务
     * @param e
     * @private
     */
    _updateAfterShownChanged = e => {
        let { onHide, onShow } = this.props;
        if (this.state.shown) {
            this._bindEvent();
            this._animationIn();
            if (onShow) onShow();
        } else {
            this._unbindEvent();
            this._animationOut();
            if (onHide) onHide(e);
        }
    };
    _animationIn = () => {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }

        const overlay = this.overlayEle.current;
        overlay.style.display = 'block'; // 显示元素

        this.fitPosition();

        if (!this.props.noAnimation) {
            overlay.classList.remove(Style.out);
            overlay.classList.add(Style.in);
        }
    };
    _animationOut = () => {
        const overlay = this.overlayEle.current;

        if (!this.props.noAnimation) {
            overlay.classList.remove(Style.in);
            overlay.classList.add(Style.out);
        }

        this.hideTimer = setTimeout(() => {
            overlay.style.display = 'none'; // 隐藏元素
        }, 90);
    };

    // 当有箭头时，面板的样式
    _getArrowClassNames = () => {
        let arrowClassName, containerClassName;
        if (this.props.hasArrow) {
            switch (this._placement) {
                case 'bottomLeft':
                case 'bottomCenter':
                case 'bottomRight':
                    arrowClassName = Style.bottom;
                    containerClassName = Style.panel_bottom;
                    break;
                case 'topLeft':
                case 'topCenter':
                case 'topRight':
                    arrowClassName = Style.top;
                    containerClassName = Style.panel_top;
                    break;
                case 'leftTop':
                case 'leftCenter':
                case 'leftBottom':
                    arrowClassName = Style.left;
                    containerClassName = Style.panel_left;
                    break;
                case 'rightTop':
                case 'rightCenter':
                case 'rightBottom':
                    arrowClassName = Style.right;
                    containerClassName = Style.panel_right;
                    break;
                default:
                    break;
            }
        }
        return {
            containerClassName: containerClassName,
            arrowClassName: arrowClassName,
        };
    };

    _hover = e => {
        e && e.stopPropagation();
        if (this.props.trigger !== 'hover' || this.state.shown) return;
        this.show(e);
    };

    render() {
        let {
            overlayClassName,
            overlayStyle = {},
            isTopLayer,
            canTriggerActive,
            hasArrow = false,
            active = true,
            triggerDisplay,
            zIndex,
            arrowClass,
            useAnchorBody,
            renderTrigger,
            renderOverlay,
            arrowStyle,
            offsetLeft = 0,
            offsetTop = 0,
        } = this.props;
        let { shown, left, top } = this.state;
        const { containerClassName, arrowClassName } = this._getArrowClassNames();

        let display = triggerDisplay || 'inline-block';
        return (
            <>
                {renderTrigger({
                    ref: this.triggerEle,
                    active: canTriggerActive ? shown : '',
                    style: { display: active ? display : 'none' },
                    onClick: this._onClick,
                    onMouseMove: this._hover,
                })}
                <FJAnchor isTopLayer={isTopLayer} useBody={useAnchorBody} zIndex={zIndex}>
                    <div
                        className={classNames(Style.drop_down_box, overlayClassName, containerClassName)}
                        ref={this.overlayEle}
                        style={{
                            overflow: hasArrow ? 'visible' : 'hidden',
                            left: left + offsetLeft,
                            top: top + offsetTop,
                            ...overlayStyle,
                        }}
                        data-auto-id='Editor_avatar'
                    >
                        {hasArrow ? (
                            <div className={classNames(Style.arrow, arrowClass, arrowClassName)} style={arrowStyle} />
                        ) : null}
                        {renderOverlay({ ref: this._menu })}
                    </div>
                </FJAnchor>
            </>
        );
    }
}

export default FJDropdownNew;
